// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__1d1w9","buttons":"RemoveExpirationActionButtons_buttons__20Lw7"};